import { tv } from "tailwind-variants";

export const cardVariants = tv({
  slots: {
    card: "",
    shadow: "",
    discount: "absolute -right-9 -top-4 size-[75px]",
    title: "",
    subtitle: "",
  },
  variants: {
    theme: {
      "green-seagreen": {
        shadow: " [--shadow:theme(colors.green.pop)]",
        card: "border border-green-50",
        discount: "[--stroke:theme(colors.green.50)]",
        title: "text-green-40",
      },
      "dark-red-pink": {
        shadow: "[--shadow:theme(colors.coral.pop)]",
        card: "border border-red-40",
        discount: "[--stroke:theme(colors.red.40)]",
        title: "text-black-80",
      },
      "blue-pink": {
        shadow: "[--shadow:theme(colors.orange.30)]",
        card: "border border-blue-30",
        discount: "[--stroke:theme(colors.blue.30)]",
        title: "text-black-80",
      },
      "green-red": {
        shadow: "[--shadow:theme(colors.yellow.40)]",
        card: "border border-green-50",
        discount: "[--stroke:theme(colors.green.50)]",
        title: "text-green-40",
      },
    },
  },
  compoundVariants: [
    {
      theme: ["green-seagreen", "green-red"],
      class: {
        title: "font-headline",
        subtitle: "text-sm !leading-6 text-green-40 md:text-base",
      },
    },
    {
      theme: ["dark-red-pink", "blue-pink"],
      class: {
        subtitle: "text-lg font-semibold !leading-10 text-black-80 md:text-xl",
      },
    },
  ],
});

export type CardVariantsClasses = ReturnType<typeof cardVariants>;
